import { render, staticRenderFns } from "./WorkflowManage.vue?vue&type=template&id=70ca24ae&scoped=true"
import script from "./WorkflowManage.vue?vue&type=script&lang=js"
export * from "./WorkflowManage.vue?vue&type=script&lang=js"
import style0 from "./WorkflowManage.vue?vue&type=style&index=0&id=70ca24ae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ca24ae",
  null
  
)

export default component.exports